module.exports = "/assets/95a4fc77b4c69e67650c72d357eed83e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5C.png
// module id = 1054
// module chunks = 0